const config={
  parse:{
    init:{
      parseAppId: 'joidea',
      parseHost:'http://localhost:1337/parse'
    },
    api:{
      payment: '/api/payments',
      getBill: 'http://km1/api/bill/get-bill?contract_id=24027'
    }
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/pages/parse/config/config.js